import { graphql } from '@/gql'

export const MilestoneFragment = graphql(/* GraphQL */ `
  fragment MilestoneType on Milestone {
    id
    name
    purchaseOrderNumber
    status
    details {
      id
      dueDate
      amount
    }
  }
`)
